var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.isActive)?_c('ActivityList',{attrs:{"filter":"deck","object-id":_vm.board.id,"object-type":"deck","type":"deck"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }